<ng-template #reprintModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Sticker Batch <b>{{batchViewing.batchid}}</b>&nbsp;|&nbsp;<span class="{{batchViewing.shippername}}">{{batchViewing.shippername}}&nbsp;{{batchViewing.container}}</span></h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body" [innerHTML]="BOLhtml"></div>
</ng-template>


<div class="main-content bg-white">
    <div class="container-fluid col-11 m-auto">
        <div class="row">
            <div class="col-md-4 m-0 p-0">
                <mat-form-field class="w-100" appearance="outline" id="whyisthisweird">
                    <mat-label>Enter a date range</mat-label>
                    <mat-date-range-input [rangePicker]="picker2">
                      <input class="w-100" matStartDate  [formControl]="fromdateCtrl" placeholder="Start date">
                      <input class="w-100" matEndDate [formControl]="todateCtrl" placeholder="End date">
                    </mat-date-range-input>
                    <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker2></mat-date-range-picker>
                  </mat-form-field>
            </div>
            <div class="col-md-4 m-0 p-0">
                <mat-form-field appearance="outline">
                    <mat-label>SHIPPER</mat-label>
                    <mat-select [formControl]="shipperTypeFilter">
                        <mat-option [value]="'all'">
                            ALL
                        </mat-option>
                        <mat-option *ngFor="let t of shipvias" [value]="t.shipper_id">
                            {{ t.shippername }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="m-0 p-0 col-11 ml-auto mr-auto bg-white mt-2">
        <input class="reprint-input w-100" type="text" [formControl]="historySearchRef" id="historySearchRef" autocomplete="off" placeholder="Sku, Order#, Name, Batch, Date, User..." (keyup)="filterOrders();" #searchRef/>
    </div>
    <div class="m-0 p-0 col-11 ml-auto mr-auto" *ngIf="batchHistoryFiltered.length">
        <table class="w-100 table table-fixed table-hover table-bordered" *ngIf="dataSource">
             <div *ngFor="let batch of dataObs | async" class="batchcontainer d-inherit w-100 mat-elevation-z4">
                    <thead>
                        <tr class="no-borders">
                            <th colspan="2" class="italics">
                                <span class="bol-btn" (click)="viewbol(batch)">
                                    BATCH&nbsp;<b>{{batch['batchid']}}</b> &nbsp; 
                                    <mat-icon class="vertical-align-bottom scale-75" *ngIf="!batch.loading">visibility</mat-icon>
                                    <ng-container *ngIf="batch.loading">
                                        <svg class="spinner" width="18px" height="18px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"> <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"> </circle> </svg>   
                                    </ng-container>
                                </span>
                            </th>
                            <th colspan="4">
                                <ng-container *ngIf="batch.shippername">
                                    <div>
                                        <span class="underline italics font-weight-lighter userid"> {{batch.ocuser}}</span> 
                                        <span>&nbsp; @ {{batch.shippedtime | date: 'short'}}</span>
                                        <span>&nbsp;|&nbsp;</span>
                                        <b class="{{batch.shippername}}">
                                            {{batch.shippername}} 
                                            <ng-container *ngIf="batch.container === 'LIVE LOAD'">
                                                <mat-icon class="vertical-align-bottom scale-75">local_shipping</mat-icon>
                                            </ng-container>
                                            <ng-container *ngIf="batch.container !== 'LIVE LOAD'">
                                                <mat-icon class="vertical-align-bottom scale-75">view_in_ar</mat-icon>
                                            </ng-container>
                                            {{batch.container}}
                                        </b>
                                    </div>
                                </ng-container>
                            </th>
                            
                            <th colspan="2" class="text-center">
                                <div class="row w-100">
                                    <div class="signature row">
                                        <p class="italics align-content-end m-0 font-weight-lighter">Signature&nbsp;&nbsp;&nbsp;</p>
                                        <img src="{{batch['signature']}}"/>
                                    </div>
                                </div>
                            </th>
                            <th colspan="3">
                                <div class="row m-0 p-0 w-100 justify-content-end no-wrap">
                                    <ng-container *ngIf="batch.showPrints">
                                        <button color="secondary" mat-mini-fab class="scale-5" (click)="showprints(batch)">
                                            <mat-icon *ngIf="!batch.printing"> keyboard_arrow_right </mat-icon> 
                                            <ng-container *ngIf="batch.printing">
                                                <svg class="spinner" width="25px" height="25px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"> <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"> </circle> </svg>
                                            </ng-container>
                                        </button> 
                                        <button color="primary"  mat-raised-button class="btn-sm print-btn float-right" (click)="reprint(batch)" [disabled]="batch.printing">Print BOL</button>
                                        <button color="accent"  mat-raised-button class="btn-sm float-right print-btn mr-1 ml-1" (click)="reprint(batch, 1)" [disabled]="batch.printing">Print Invoices</button>
                                    </ng-container>
                                    <button mat-mini-fab color="secondary" class="float-right scale-5" *ngIf="!batch.showPrints" (click)="showprints(batch)"><mat-icon>keyboard_arrow_left</mat-icon></button> 
                                </div>
                            </th>
                        </tr>
                        <tr>
                            <th>ORDER#</th>
                            <th>TERMS</th>
                            <th class="col-1">REF</th>
                            <th class="col-1">TRACK#</th>
                            <th class="col-1">BUYER</th>  
                            <th class="text-center">QTY</th>
                            <th class="col-3 text-left">SKU</th>
                            <!-- <th class="col-2 text-left">DESC.</th> -->
                            <th class="text-center col-2">PACKED</th>
                            <th class="text-center col-2">RTS</th>
                        </tr>
                    </thead>
                    <tbody class="striped-rows">
                        <ng-container *ngFor="let ord of batch['orders']">
                            <tr [ngClass]="{'highlight' : historymatches.length && historymatches.includes(ord.orderno), 'autherror pointer' : ord.preauthstatus?.toLowerCase().includes('declined'), 'authsuccess pointer' : ord.preauthstatus && !ord.preauthstatus?.toLowerCase().includes('declined') }">
                                <td>{{ord.orderno}}</td>
                                <td>{{ord.payterms}}</td>
                                <td>{{ord.reference}}</td>
                                <td>{{ord.trackingnumber}}</td>
                                <td>{{ord.name}}</td>
                                <td class="text-center">{{ord.quantity}}</td>
                                <td class="text-left"><span class="font-weight-bold">{{ord.stockid}}</span><hr class="m-0 p-0"/><span class="font-weight-lighter">{{ord.description}}</span></td>
                                <!-- <td class="text-left">{{ord.description}}</td> -->
                                <td class="text-center"><span class="underline italics font-weight-lighter userid">{{ord.packeduserid}}</span> @ {{ord.packedtime | date:'short'}} </td>
                                <td class="text-center"><span class="underline italics font-weight-lighter userid">{{ord.stageduserid}}</span> @ {{ord.stagedtime | date:'short'}} </td>
                            </tr>
                            <td colspan="9" *ngIf="ord.preauthstatus">
                                <div class="nowrap row w-100 m-0 p-0">
                                    <h5 class="lighter">AUTH RESPONSE&nbsp;&nbsp;</h5>{{ord.payterms | uppercase}} ::: {{ord.preauthstatus | uppercase}}
                                </div>
                            </td>
                        </ng-container>
                    </tbody>
                    <div class="w-100 mb-1 p-0"></div>
                </div>
        </table>
        <mat-paginator class="border-top" [pageSizeOptions]="items_per_page" [pageSize]="pagesizedefault"></mat-paginator> 
    </div>
    <div class="p-0 col-11 ml-auto mr-auto text-center bg-white tabled-bordered" *ngIf="!batchHistoryFiltered.length">
        <p *ngIf="!historyLoading">No history found</p>
        <svg *ngIf="historyLoading" class="spinner" width="65px" height="65px" viewBox="0 0 66 66"
            xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30">
            </circle>
        </svg>
    </div>
</div>